
        require('./index.scss');
        'use strict';

var $ = window.$;
var _module = {
    init: function init() {
        var author = $('.authorInfo');
        var url = author.attr('data-url');
        author.click(function () {
            if (url) {
                window.open(url);
            }
        });
    }
};
_module.init();;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/more/index.js